export const PUBLISHER_PROFILE_COPY = {
  follow: 'Follow',
  following: 'Following',
  descriptionImageAltTag: (pubName: string) => `${pubName} description`,
};
